var _style, _g, _g2, _ellipse, _g3, _polygon, _polygon2, _polygon3, _path, _path2, _rect, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebdevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E0032;}\r\n\t.st1{fill:#78A4EB;}\r\n\t.st2{fill:none;stroke:#AE6FFA;stroke-width:1.545;stroke-miterlimit:10;stroke-dasharray:3.09,3.09;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:#171717;}\r\n\t.st5{fill:#A5A9B7;}\r\n\t.st6{fill:url(#SVGID_2_);}\r\n\t.st7{fill:#1761B0;}\r\n\t.st8{fill:#D25A2C;}\r\n\t.st9{fill:#69B884;}\r\n\t.st10{fill:#CB2376;}\r\n\t.st11{fill:#66A8DE;}\r\n\t.st12{fill:none;stroke:#92E8C2;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#8DCBFC;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st14{fill:#FFFFFF;}\r\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:0.657;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st16{fill:#455C9A;}\r\n\t.st17{fill:#DA8F48;}\r\n\t.st18{fill:none;stroke:#DD6309;stroke-width:1.0669;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st19{fill:none;stroke:#FFFFFF;stroke-width:1.2054;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st20{fill:#8D78B2;}\r\n\t.st21{fill:none;stroke:#374FA6;stroke-width:0.7638;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:#282D41;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st24{fill:#0C3580;}\r\n\t.st25{font-family:'ArialMT';}\r\n\t.st26{font-size:25.6898px;}\r\n\t.st27{fill:#3359D0;}\r\n\t.st28{fill:#D1EBF8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.09,
    y: 457.04,
    className: "st0",
    width: 280.69,
    height: 3.09
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 241.14,
    cy: 259.85,
    rx: 189.07,
    ry: 189.07
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.18,159.76v227.89c0,8.52-6.93,15.45-15.45,15.45H287.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.1,369.37V159.76c0-8.52,6.93-15.45,15.45-15.45H195"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.88,
    y1: 105.165,
    x2: 295.4,
    y2: 105.165,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "264.89,368.6 217.39,368.6 186.88,449.07 295.4,449.07  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "301.54,460.11 180.74,460.11 175.51,448.92 306.77,448.92  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "207.19,395.51 286.32,425.12 271.8,386.82 210.48,386.82  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.82,
    y1: 240.29,
    x2: 406.46,
    y2: 240.29,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M398.73,395.38H83.55c-4.27,0-7.73-3.46-7.73-7.73V159.76c0-4.27,3.46-7.72,7.73-7.72h315.18 c4.27,0,7.73,3.46,7.73,7.72v227.89C406.46,391.92,403,395.38,398.73,395.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.29,161.57c0,2.84-2.31,5.15-5.15,5.15s-5.15-2.31-5.15-5.15s2.31-5.15,5.15-5.15 C243.98,156.42,246.29,158.72,246.29,161.57z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.37,
    y: 170.58,
    className: "st7",
    width: 293.55,
    height: 198.02
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M21.58,409.53c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 C20.43,406.96,21.58,408.11,21.58,409.53z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 29.95,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 40.88,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 51.82,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 62.75,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 73.68,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 84.61,
    cy: 409.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 95.55,
    cy: 409.53,
    r: 2.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M233.69,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 C232.54,103.08,233.69,104.23,233.69,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.62,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 C243.48,103.08,244.62,104.23,244.62,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M255.56,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S255.56,104.23,255.56,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266.49,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S266.49,104.23,266.49,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M277.42,105.64c0,1.42-1.15,2.56-2.56,2.56s-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S277.42,104.23,277.42,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M288.36,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S288.36,104.23,288.36,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M299.29,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S299.29,104.23,299.29,105.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M310.22,105.64c0,1.42-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.56 S310.22,104.23,310.22,105.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M441.53,362.65c0,3.69-2.99,6.68-6.68,6.68s-6.68-2.99-6.68-6.68s2.99-6.68,6.68-6.68 S441.53,358.96,441.53,362.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.93,146.82c0,3.69-2.99,6.68-6.68,6.68s-6.68-2.99-6.68-6.68c0-3.69,2.99-6.68,6.68-6.68 C52.94,140.14,55.93,143.13,55.93,146.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M156.67,398.45c0,3.69-2.99,6.68-6.68,6.68c-3.69,0-6.68-2.99-6.68-6.68s2.99-6.68,6.68-6.68 C153.68,391.78,156.67,394.77,156.67,398.45z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 109.28,
    y1: 187.07,
    x2: 226.5,
    y2: 187.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.17,
    y1: 187.07,
    x2: 275.14,
    y2: 187.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 109.28,
    y1: 270.5,
    x2: 226.5,
    y2: 270.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 270.5,
    x2: 259.32,
    y2: 270.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 109.28,
    y1: 294.49,
    x2: 226.5,
    y2: 294.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.17,
    y1: 294.49,
    x2: 259.32,
    y2: 294.49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 109.28,
    y1: 337.14,
    x2: 226.5,
    y2: 337.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 337.14,
    x2: 275.14,
    y2: 337.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 189.87,
    y1: 343.8,
    x2: 226.5,
    y2: 343.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.17,
    y1: 343.8,
    x2: 275.14,
    y2: 343.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 135.36,
    y1: 196.67,
    x2: 226.5,
    y2: 196.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 196.67,
    x2: 250.53,
    y2: 196.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 135.36,
    y1: 202.53,
    x2: 226.5,
    y2: 202.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 202.53,
    x2: 261.08,
    y2: 202.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 135.36,
    y1: 208.4,
    x2: 226.5,
    y2: 208.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.17,
    y1: 208.4,
    x2: 250.53,
    y2: 208.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 135.36,
    y1: 214.26,
    x2: 226.5,
    y2: 214.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 214.26,
    x2: 261.08,
    y2: 214.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 135.36,
    y1: 220.12,
    x2: 226.5,
    y2: 220.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 220.12,
    x2: 250.53,
    y2: 220.12
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 227.32,
    x2: 226.5,
    y2: 227.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 227.32,
    x2: 266.35,
    y2: 227.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 234.52,
    x2: 226.5,
    y2: 234.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 234.52,
    x2: 266.35,
    y2: 234.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 241.71,
    x2: 214.78,
    y2: 241.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 224.45,
    y1: 241.71,
    x2: 266.35,
    y2: 241.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 248.91,
    x2: 226.5,
    y2: 248.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 248.91,
    x2: 266.35,
    y2: 248.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 256.11,
    x2: 214.78,
    y2: 256.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 224.45,
    y1: 256.11,
    x2: 266.35,
    y2: 256.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 169.65,
    y1: 263.3,
    x2: 226.5,
    y2: 263.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 236.17,
    y1: 263.3,
    x2: 266.35,
    y2: 263.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 184.01,
    y1: 280.1,
    x2: 240.86,
    y2: 280.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 250.53,
    y1: 280.1,
    x2: 280.71,
    y2: 280.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 184.01,
    y1: 287.29,
    x2: 224.45,
    y2: 287.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 234.12,
    y1: 287.29,
    x2: 280.71,
    y2: 287.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 207.16,
    y1: 303.82,
    x2: 224.45,
    y2: 303.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 234.12,
    y1: 303.82,
    x2: 266.35,
    y2: 303.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 212.43,
    y1: 310.48,
    x2: 224.45,
    y2: 310.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 234.12,
    y1: 310.48,
    x2: 275.14,
    y2: 310.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 207.16,
    y1: 317.15,
    x2: 224.45,
    y2: 317.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 234.12,
    y1: 317.15,
    x2: 266.35,
    y2: 317.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 212.43,
    y1: 323.81,
    x2: 224.45,
    y2: 323.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 234.12,
    y1: 323.81,
    x2: 275.14,
    y2: 323.81
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9215 -0.3884 0.3884 0.9215 -101.4904 48.5515)",
    className: "st14",
    cx: 69.35,
    cy: 275.32,
    rx: 18.21,
    ry: 18.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.04,261.77c3.14,3.64,5.05,8.38,5.05,13.56c0,11.45-9.29,20.74-20.74,20.74c-2.8,0-5.46-0.55-7.9-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M55.31,290.6c-4.12-3.79-6.7-9.23-6.7-15.27c0-11.45,9.29-20.74,20.74-20.74"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M71.73,266.85h1.5l-5.68,16.22h-1.5L71.73,266.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M81.46,274.58v1.48l-7.71,3.05v-1.43l6.13-2.36l-6.13-2.36v-1.43L81.46,274.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M57.23,276.06v-1.48l7.71-3.05v1.43l-6.13,2.36l6.13,2.36v1.43L57.23,276.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 122.77,
    cy: 85.67,
    rx: 29.57,
    ry: 29.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M148.26,63.65c5.11,5.9,8.19,13.6,8.19,22.02c0,18.6-15.08,33.68-33.68,33.68c-4.54,0-8.87-0.9-12.82-2.53 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.98,110.47c-6.69-6.16-10.89-14.99-10.89-24.8c0-18.6,15.08-33.68,33.68-33.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M110.32,91.21l1.79-2.15c0.92,1.26,2.03,1.93,3.36,1.93c1.74,0,2.64-1.04,2.64-3.12v-8.75h-6.02v-2.64 h9.16V87.7c0,3.99-1.98,5.95-5.71,5.95C113.42,93.65,111.48,92.78,110.32,91.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.9,92.13l1.16-2.3c1.14,0.75,2.88,1.28,4.5,1.28c1.91,0,2.71-0.53,2.71-1.43 c0-2.47-7.98-0.14-7.98-5.3c0-2.44,2.2-4.04,5.69-4.04c1.72,0,3.67,0.41,4.84,1.11l-1.16,2.3c-1.23-0.73-2.47-0.97-3.7-0.97 c-1.84,0-2.71,0.6-2.71,1.45c0,2.61,7.98,0.29,7.98,5.34c0,2.42-2.23,3.99-5.85,3.99C127.21,93.58,125.06,92.95,123.9,92.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 206.27,
    cy: 125.59,
    r: 33.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M235.06,100.71c5.77,6.67,9.26,15.37,9.26,24.88c0,21.02-17.04,38.05-38.05,38.05 c-5.13,0-10.02-1.02-14.49-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M180.52,153.6c-7.56-6.95-12.3-16.93-12.3-28.02c0-21.02,17.04-38.05,38.05-38.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M198.41,123.9c0,2.57-1.9,4.16-4.98,4.16h-2.64v3.38h-2.17v-11.7h4.81 C196.51,119.74,198.41,121.31,198.41,123.9z M196.22,123.9c0-1.47-0.98-2.32-2.89-2.32h-2.54v4.65h2.54 C195.24,126.22,196.22,125.37,196.22,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M210.98,119.74v11.7h-2.17v-5.01h-6.05v5.01h-2.17v-11.7h2.17v4.83h6.05v-4.83 C208.81,119.74,210.98,119.74,210.98,119.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M223.92,123.9c0,2.57-1.9,4.16-4.98,4.16h-2.64v3.38h-2.17v-11.7h4.81 C222.02,119.74,223.92,121.31,223.92,123.9z M221.73,123.9c0-1.47-0.98-2.32-2.89-2.32h-2.54v4.65h2.54 C220.75,126.22,221.73,125.37,221.73,123.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 44.68,
    cy: 215.36,
    r: 34.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M74.3,189.76c5.93,6.86,9.53,15.81,9.53,25.6c0,21.62-17.53,39.15-39.15,39.15 c-5.28,0-10.31-1.04-14.91-2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M18.18,244.18c-7.78-7.16-12.66-17.42-12.66-28.82c0-21.62,17.53-39.15,39.15-39.15"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M32.34,210.67v10.68h-1.98v-4.58h-5.52v4.58h-1.98v-10.68h1.98v4.41h5.52v-4.41L32.34,210.67 L32.34,210.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M37.36,212.35h-3.54v-1.68h9.06v1.68h-3.54v9h-1.98V212.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54.18,221.35l-0.02-7.08l-3.51,5.86h-0.88l-3.51-5.77v6.99h-1.89v-10.68H46l4.24,7.08l4.16-7.08h1.63 l0.02,10.68H54.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M58.94,210.67h1.98v9h5.58v1.68h-7.56V210.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 467.32,
    cy: 313.67,
    r: 34.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M496.95,288.08c5.93,6.86,9.53,15.81,9.53,25.6c0,21.62-17.53,39.15-39.15,39.15 c-5.28,0-10.31-1.04-14.91-2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M440.83,342.5c-7.78-7.16-12.66-17.42-12.66-28.82c0-21.62,17.53-39.15,39.15-39.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 40.5,
    cy: 123.48,
    rx: 21.17,
    ry: 21.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M58.75,107.73c3.66,4.23,5.87,9.74,5.87,15.76c0,13.32-10.8,24.11-24.11,24.11 c-3.25,0-6.35-0.64-9.18-1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M24.19,141.24c-4.79-4.41-7.79-10.73-7.79-17.75c0-13.32,10.8-24.11,24.11-24.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M28.32,123.39c0-3.02,2.32-5.21,5.43-5.21c1.65,0,3.07,0.59,4.01,1.69l-1.22,1.14 c-0.74-0.8-1.65-1.19-2.71-1.19c-2.1,0-3.62,1.48-3.62,3.56c0,2.08,1.52,3.56,3.62,3.56c1.06,0,1.97-0.39,2.71-1.2l1.22,1.16 c-0.94,1.1-2.36,1.69-4.02,1.69C30.63,128.6,28.32,126.42,28.32,123.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M45.49,124.01h-2.17v2.15H42v-2.15h-2.17v-1.23H42v-2.15h1.31v2.15h2.17L45.49,124.01L45.49,124.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M52.69,124.01h-2.17v2.15h-1.31v-2.15h-2.17v-1.23h2.17v-2.15h1.31v2.15h2.17 C52.69,122.78,52.69,124.01,52.69,124.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 142.4389 351.4169)",
    className: "st7",
    cx: 277.74,
    cy: 92,
    rx: 22.64,
    ry: 22.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M297.26,75.14c3.91,4.52,6.27,10.41,6.27,16.86c0,14.24-11.55,25.79-25.79,25.79 c-3.48,0-6.79-0.69-9.82-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M260.29,110.98c-5.12-4.71-8.34-11.47-8.34-18.99c0-14.24,11.55-25.79,25.79-25.79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M264.16,91.89c0-2.98,2.28-5.14,5.36-5.14c1.63,0,3.03,0.59,3.96,1.67l-1.2,1.13 c-0.73-0.79-1.63-1.17-2.67-1.17c-2.07,0-3.57,1.46-3.57,3.51s1.5,3.51,3.57,3.51c1.04,0,1.94-0.39,2.67-1.18l1.2,1.14 c-0.93,1.09-2.33,1.67-3.97,1.67C266.44,97.03,264.16,94.88,264.16,91.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M274.36,95.83l0.64-1.44c0.8,0.64,2.07,1.1,3.3,1.1c1.56,0,2.21-0.56,2.21-1.3 c0-2.16-5.94-0.74-5.94-4.46c0-1.61,1.28-2.98,4.03-2.98c1.2,0,2.46,0.31,3.33,0.88l-0.59,1.44c-0.9-0.53-1.88-0.79-2.76-0.79 c-1.54,0-2.17,0.6-2.17,1.36c0,2.13,5.93,0.74,5.93,4.41c0,1.6-1.3,2.97-4.04,2.97C276.74,97.03,275.19,96.55,274.36,95.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M283.35,95.83l0.64-1.44c0.8,0.64,2.07,1.1,3.3,1.1c1.56,0,2.21-0.56,2.21-1.3 c0-2.16-5.94-0.74-5.94-4.46c0-1.61,1.28-2.98,4.03-2.98c1.2,0,2.46,0.31,3.33,0.88l-0.59,1.44c-0.9-0.53-1.88-0.79-2.76-0.79 c-1.54,0-2.17,0.6-2.17,1.36c0,2.13,5.93,0.74,5.93,4.41c0,1.6-1.3,2.97-4.04,2.97C285.73,97.03,284.17,96.55,283.35,95.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M237.28,59.04l-3.66,0.19l0.19-3.65c-1.4-0.95-3-1.62-4.72-1.95l-2.45,2.71l-2.45-2.71 c-1.72,0.33-3.32,1-4.72,1.95l0.19,3.65L216,59.04c-0.95,1.4-1.62,3-1.95,4.72l2.71,2.45l-2.71,2.45c0.33,1.72,1,3.32,1.95,4.72 l3.65-0.19l-0.19,3.66c1.4,0.95,3,1.62,4.72,1.95l2.45-2.71l2.45,2.71c1.72-0.33,3.32-1,4.72-1.95l-0.19-3.66l3.66,0.19 c0.95-1.4,1.62-3,1.95-4.72l-2.71-2.45l2.71-2.45C238.89,62.04,238.22,60.44,237.28,59.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M232.25,66.21c0,3.1-2.51,5.61-5.61,5.61s-5.61-2.51-5.61-5.61s2.51-5.61,5.61-5.61 S232.25,63.11,232.25,66.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M366.07,302.52l-3.66,0.19l0.19-3.65c-1.4-0.95-3-1.62-4.72-1.95l-2.45,2.71l-2.45-2.71 c-1.72,0.33-3.32,1-4.72,1.95l0.19,3.65l-3.66-0.19c-0.95,1.4-1.62,3-1.95,4.72l2.71,2.45l-2.71,2.45 c0.33,1.72,1,3.32,1.95,4.72l3.66-0.19l-0.19,3.66c1.4,0.95,3,1.62,4.72,1.95l2.45-2.71l2.45,2.71c1.72-0.33,3.32-1,4.72-1.95 l-0.19-3.66l3.66,0.19c0.95-1.4,1.62-3,1.95-4.72l-2.71-2.45l2.71-2.45C367.69,305.52,367.02,303.92,366.07,302.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M361.05,309.69c0,3.1-2.51,5.61-5.61,5.61c-3.1,0-5.61-2.51-5.61-5.61c0-3.1,2.51-5.61,5.61-5.61 C358.53,304.08,361.05,306.59,361.05,309.69z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M40.1,270.9c-0.23-1.19-0.7-2.3-1.35-3.28l-2.54,0.13l0.13-2.54c-0.97-0.66-2.08-1.12-3.28-1.35l-1.7,1.88 l-1.7-1.88c-1.19,0.23-2.3,0.7-3.28,1.35l0.13,2.54l-2.54-0.13c-0.66,0.97-1.12,2.08-1.35,3.28l1.88,1.7l-1.88,1.7 c0.23,1.19,0.7,2.3,1.35,3.28l2.54-0.13l-0.13,2.54c0.97,0.66,2.08,1.12,3.28,1.35l1.7-1.88l1.7,1.88 c1.19-0.23,2.3-0.7,3.28-1.35l-0.13-2.54l2.54,0.13c0.66-0.97,1.12-2.08,1.35-3.28l-1.88-1.7L40.1,270.9z M31.36,276.49 c-2.15,0-3.89-1.74-3.89-3.89c0-2.15,1.74-3.89,3.89-3.89s3.89,1.74,3.89,3.89C35.26,274.75,33.51,276.49,31.36,276.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.79,58.9c-0.23-1.19-0.7-2.3-1.35-3.28l-2.54,0.13l0.13-2.54c-0.97-0.66-2.08-1.12-3.28-1.35l-1.7,1.88 l-1.7-1.88c-1.19,0.23-2.3,0.7-3.28,1.35l0.13,2.54l-2.54-0.13c-0.66,0.97-1.12,2.08-1.35,3.28l1.88,1.7l-1.88,1.7 c0.23,1.19,0.7,2.3,1.35,3.28l2.54-0.13l-0.13,2.54c0.97,0.66,2.08,1.12,3.28,1.35l1.7-1.88l1.7,1.88 c1.19-0.23,2.3-0.7,3.28-1.35l-0.13-2.54l2.54,0.13c0.66-0.97,1.12-2.08,1.35-3.28l-1.88-1.7L408.79,58.9z M400.06,64.49 c-2.15,0-3.89-1.74-3.89-3.89c0-2.15,1.74-3.89,3.89-3.89s3.89,1.74,3.89,3.89C403.95,62.75,402.21,64.49,400.06,64.49z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 442.2006 321.9471)",
    className: "st14 st25 st26"
  }, ".NET"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M450.36,198.47v-9.63l-6.2-1.25l0,0c-0.17-0.45-0.36-0.9-0.56-1.33l0.01,0.01l3.5-5.27l-6.81-6.81 l-5.27,3.5l0.01,0.01c-0.44-0.2-0.88-0.39-1.33-0.56l0,0l-1.25-6.2h-9.63l-1.25,6.2l0,0c-0.45,0.17-0.9,0.36-1.33,0.56 l0.01-0.01l-5.27-3.5l-6.81,6.81l3.5,5.27l0.01-0.01c-0.2,0.44-0.39,0.88-0.56,1.33l0,0l-6.2,1.25v9.63l6.2,1.25l0,0 c0.17,0.45,0.36,0.9,0.56,1.33l-0.01-0.01l-3.5,5.27l6.81,6.81l5.27-3.5l-0.01-0.01c0.44,0.2,0.88,0.39,1.33,0.56l0,0l1.25,6.2 h9.63l1.25-6.2l0,0c0.45-0.17,0.9-0.36,1.33-0.56l-0.01,0.01l5.27,3.5l6.81-6.81l-3.5-5.27l-0.01,0.01 c0.2-0.44,0.39-0.88,0.56-1.33l0,0L450.36,198.47z M427.64,202.66c-4.97,0-9-4.03-9-9s4.03-9,9-9s9,4.03,9,9 S432.61,202.66,427.64,202.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M320.07,243.94l13.01,13.01l10.27-6.82l-0.02-0.02c0.85,0.39,1.71,0.76,2.6,1.09l0,0l2.44,12.09h18.77 l2.44-12.09l0,0c0.88-0.32,1.75-0.69,2.6-1.09l-0.02,0.02l10.27,6.82l13.01-13.01L320.07,243.94L320.07,243.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M392.95,221.1v-18.77l-12.09-2.44l0,0c-0.33-0.88-0.69-1.75-1.09-2.6l0.02,0.02l6.82-10.27 l-13.27-13.27l-10.27,6.82l0.02,0.02c-0.85-0.39-1.71-0.76-2.6-1.09l0,0l-2.44-12.09h-18.77l-2.44,12.09l0,0 c-0.88,0.33-1.75,0.69-2.6,1.09l0.02-0.02l-10.27-6.82l-13.27,13.27l6.82,10.27l0.02-0.02c-0.39,0.85-0.76,1.71-1.09,2.6l0,0 l-12.08,2.44v18.77l12.08,2.44l0,0c0.33,0.88,0.69,1.75,1.09,2.6l-0.02-0.02l-6.82,10.27l13.27,13.27l10.27-6.82l-0.02-0.02 c0.85,0.39,1.71,0.76,2.6,1.09l0,0l2.44,12.09h18.77l2.44-12.09l0,0c0.88-0.33,1.75-0.69,2.6-1.09l-0.02,0.02l10.27,6.82 l13.27-13.27l-6.82-10.27l-0.02,0.02c0.39-0.85,0.76-1.71,1.09-2.6l0,0L392.95,221.1z M348.68,229.25 c-9.69,0-17.54-7.85-17.54-17.54s7.85-17.54,17.54-17.54s17.54,7.85,17.54,17.54S358.36,229.25,348.68,229.25z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdevelopment);
export default __webpack_public_path__ + "static/media/webdevelopment.8cdf370fb87ddc53a617b42a83772a9c.svg";
export { ForwardRef as ReactComponent };